import clsx from "clsx";
import React, { useState } from "react";

import ChangeCourseLevelModal from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/Level/ChangeCourseLevelModal";
import AdditionalInformation from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/Level/Course/AdditionalInformation";
import ControlButtons from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/Level/Course/ControlButtons";
import { useGetLocationData } from "~/hooks/locationData";
import { StatusOptions } from "~/shared/lib/statuses";

import s from "./CourseCard.less";

type Props = {
  course;
  certificateValidityPeriod;
  setIsEditCourse;
  setIsMoreDetails;
  handleDeleteCourse;
  isMoreDetails;
  handleShowMoreDetails;
  handleCloseModal: () => void;
  handleOpenModal: () => void;
  fieldsConfig;
  level;
  refetch;
};
const CourseCard = (props: Props) => {
  const {
    course,
    certificateValidityPeriod,
    setIsEditCourse,
    setIsMoreDetails,
    handleDeleteCourse,
    isMoreDetails,
    handleShowMoreDetails,
    handleOpenModal,
    fieldsConfig,
    level,
    refetch,
  } = props;

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const certificationPeriod = certificateValidityPeriod
    ? certificateValidityPeriod
    : "Бессрочно";
  const isActive = course?.status === "active";

  const { openType } = useGetLocationData();
  const isEdit = openType === "Edit";

  const onHandleOpenModal = () => {
    setIsOpenModal(true);
  };
  const onHandleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <div className={s.course_card_wrapper}>
      <div className={s.course_card}>
        <div className={s.course_card_item}>
          <span className={s.course_card_title}>Название</span>
          <span className={s.course_card_title_content}>{course.name}</span>
        </div>
        <div className={s.course_card_item}>
          <span className={s.course_card_title}>Срок действия сертификата</span>
          <span className={s.course_card_title_content}>
            {certificationPeriod}
          </span>
        </div>
        <div className={s.buttons}>
          <ControlButtons
            setIsEditCourse={setIsEditCourse}
            setIsMoreDetails={setIsMoreDetails}
            handleDeleteCourse={handleDeleteCourse}
            course={course}
            isMoreDetails={isMoreDetails}
            handleShowMoreDetails={handleShowMoreDetails}
            handleOpenModal={handleOpenModal}
          />
        </div>
        <div
          title={"статус курса"}
          className={clsx(s.status_absolute, isActive ? s.active : s.inactive)}
        >
          <span>{StatusOptions[course.status]}</span>
        </div>
        {isEdit && (
          <div className={s.options} onClick={onHandleOpenModal}>
            <span>&#9776;</span>
          </div>
        )}
      </div>
      <AdditionalInformation
        fieldsConfig={fieldsConfig}
        isMoreDetails={isMoreDetails}
      />
      <ChangeCourseLevelModal
        isShowModal={isOpenModal}
        onHandleCloseModal={onHandleCloseModal}
        level={level}
        course={course}
        refetch={refetch}
      />
    </div>
  );
};

export default CourseCard;
